<!--
 * @Descripttion: 
 * @version: 
 * @Author: Francis
 * @Date: 2022-07-27 00:50:40
 * @LastEditors: Francis
 * @LastEditTime: 2022-07-31 02:03:27
-->
<template>
  <div class="orderItem">
    <div class="inner">
      <div class="top">
        <div class="bizName">
          {{
            `${info.shipName || "--"}(${
              info.shipType == 2 ? "江船" : info.shipType == 3 ? "小船" : ""
            })`
          }}
        </div>
      </div>

      <div class="info">
        <div class="li">
          VIP状态：{{
            info.vipStatus == 0
              ? "未收费"
              : info.vipStatus == 1
              ? "待收款"
              : info.vipStatus == 2
              ? "已收款"
              : info.vipStatus == 3
              ? "已到期"
              : "--"
          }}
        </div>
        <div class="li1">VIP到期时间：{{ info.vipDate || "--" }}</div>
        <div class="li">
          VIP级别：{{
            info.vipLevel == 1 ? "3580" : info.vipLevel == 2 ? "1588" : "--"
          }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  props: {
    info: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {};
  },
  computed: {},

  mounted() {},
  methods: {},
};
</script>

<style lang="less" scoped>
.orderItem {
  width: 96%;
  background: #ffffff;
  border-radius: 10px;
  margin: 0 auto 10px;
  padding: 0 15px;
  .inner {
    padding: 15px 0;
    .top {
      padding-bottom: 10px;
      position: relative;

      .bizName {
        font-size: 16px;
        font-family: Source Han Sans CN, Source Han Sans CN-Medium;
        font-weight: 500;
        color: #333333;
        padding: 2px 0;
        line-height: 16px;
        margin-bottom: 2px;
      }
    }

    .info {
      border-top: 1px solid #eeeeee;
      padding-top: 10px;
      display: flex;
      flex-wrap: wrap;
      font-size: 14px;
      .li {
        width: 40%;
        height: 30px;
      }
      .li1 {
        width: 60%;
        height: 30px;
      }
    }
  }
}
</style>